import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[trimValue]",
})
export class TrimValueDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener("blur")
  onBlur() {
    const value = this.ngControl.value;
    if (typeof value === "string") {
      const trimmed_value = value.replace(/  +/g, " ").trim();
      this.ngControl.control.setValue(trimmed_value);
    }
  }
}
